<div *ngIf="!currentField" class="customize-newField-config">
  <ul nz-menu nzMode="inline">
    <!-- CHỌN THÔNG SỐ -->
    <li nz-submenu nzTitle="{{'chon_thong_so' | translate}}">
      <div>
        <mat-form-field *ngIf="staticdata.id_main_sector == 'snimei'" appearance="fill">
          <mat-label>{{'nhom_tra_cuu' | translate}}</mat-label>
          <mat-select [(ngModel)]="staticdata.lookup_group" (ngModelChange)="changeLookupGroup($event)">
            <mat-option *ngFor="let item of lookupGroupArray" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 100%">
          <mat-label>{{'thong_so_san_pham' | translate}}</mat-label>
          <mat-select [(ngModel)]="staticdata.field_custom" (ngModelChange)="onChangeFieldCustom($event)"
            [disabled]="newFields.length == 0">
            <mat-option *ngFor="let item of newFields" [value]="item.field_custom">{{item?.field_lable ??
              item.field_custom}}</mat-option>
          </mat-select>
        </mat-form-field>
        <p class="line-normal" style="color: rgb(212, 78, 78);">
          {{
          'vui_long_vao_trang_admin_truong_du_lieu_tu_tao_tao_du_lieu_sau_do_quay_lai_day_chon_truong_du_lieu' | translate
          }}
        </p>
      </div>
    </li>
  </ul>
</div>

<ng-container *ngIf="currentField">
  <atw-newField-text-config *ngIf="objectChoosing.resize_field == 'text'" [objectChoosing]="objectChoosing"
    [device]="device" [class]="class" [config]="config" [type]="type" [staticdata]="staticdata">
  </atw-newField-text-config>
  <atw-newField-input-config *ngIf="objectChoosing.resize_field == 'input__boundary'" [objectChoosing]="objectChoosing"
    [device]="device" [class]="class" [config]="config" [type]="type" [staticdata]="staticdata">
  </atw-newField-input-config>
  <atw-newField-select-config *ngIf="objectChoosing.resize_field == 'select__boundary'"
    [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config" [type]="type"
    [staticdata]="staticdata">
  </atw-newField-select-config>
  <atw-newField-radio-button-config *ngIf="objectChoosing.resize_field == 'radio'" [objectChoosing]="objectChoosing"
    [device]="device" [class]="class" [config]="config" [type]="type" [staticdata]="staticdata">
  </atw-newField-radio-button-config>
  <atw-newField-image-config *ngIf="objectChoosing.resize_field == 'image'" [objectChoosing]="objectChoosing"
    [device]="device" [class]="class" [config]="config" [type]="type" [staticdata]="staticdata">
  </atw-newField-image-config>
</ng-container>